import React, { useMemo } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const ALL_OPTION = { id: 'all', name: 'All engineers' };

const useStyles = makeStyles(theme => ({
  // Autocomplete's internal slots (v4) are what controls vertical alignment
  // of the popup indicator (caret). Global/flex layout styles sometimes break it.
  inputRoot: {
    display: 'flex',
    alignItems: 'center',
    // For small outlined TextField, keep height predictable.
    paddingTop: 0,
    paddingBottom: 0,
  },
  input: {
    lineHeight: '16px',
  },
  endAdornment: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 0,
  },
  popupIndicator: {
    marginTop: 0,
    marginBottom: 0,
    alignSelf: 'center',
  },
}));

/**
 * Searchable engineer filter for Platform timesheet pages.
 */
const EngineerAutocomplete = ({
  engineers = [],
  value = 'all',
  onChange,
  label = 'Engineer',
  allLabel = 'All engineers',
  style,
  className,
  size = 'small',
}) => {
  const classes = useStyles();
  const options = useMemo(
    () => [
      { id: 'all', name: allLabel },
      ...[...engineers].sort((a, b) =>
        (a.name || '').localeCompare(b.name || '', undefined, {
          sensitivity: 'base',
        }),
      ),
    ],
    [engineers, allLabel],
  );

  const selected =
    options.find(opt => opt.id === value) || options[0] || ALL_OPTION;

  return (
    <Autocomplete
      className={className}
      style={style}
      options={options}
      value={selected}
      getOptionLabel={opt => (opt && opt.name) || ''}
      getOptionSelected={(opt, val) => opt.id === val.id}
      onChange={(_event, next) => {
        if (typeof onChange === 'function') {
          onChange(next && next.id ? next.id : 'all');
        }
      }}
      classes={{
        inputRoot: classes.inputRoot,
        input: classes.input,
        endAdornment: classes.endAdornment,
        popupIndicator: classes.popupIndicator,
      }}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          size={size}
          InputProps={{
            ...params.InputProps,
            classes: {
              ...(params.InputProps && params.InputProps.classes),
              input: classes.input,
            },
          }}
        />
      )}
    />
  );
};

export default EngineerAutocomplete;
